import { InputBaseComponentProps } from "@mui/material";
import React from "react";
import { IMaskInput } from "react-imask";

interface CustomProps extends InputBaseComponentProps{
    onChange: (event: any) => void;
    name: string;
  }
  
  const ContactFormatter = React.forwardRef<HTMLInputElement, CustomProps>(
    function TextMaskCustom(props, ref) {
      const { onChange, ...other } = props;
      return (
        <IMaskInput
          {...other}
          mask="(#00) 000-0000"
          definitions={{
            '#': /[1-9]/,
          }}
          inputRef={ref}
          onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
          overwrite
        />
      );
    },
  );

  export default ContactFormatter;